import type { Blueprint } from '../../base/blueprints/Blueprint';
import { instanceOfBlueprint } from '../../base/blueprints/Blueprint';
import type { AlwaysChoice } from '../enums/AlwaysChoice';
import type { NeverChoice } from '../enums/NeverChoice';
import type { WhenChoice } from '../enums/WhenChoice';

export interface RequiredBlueprint extends Blueprint
{
    required: AlwaysChoice | NeverChoice | WhenChoice;
    requiredWhen: string;
}

export const instanceOfRequiredBlueprint = (object: any): object is RequiredBlueprint =>
{
    return instanceOfBlueprint(object) && 'required' in object;
};
